export default __webpack_public_path__ + "static/media/plus-circle-blue.3c6851e6.svg";